import PieChart from "components/charts/PieChart";
import { pieChartData, pieChartOptions } from "variables/charts";
import Card from "components/card";
import {useEffect, useState} from "react";
import useAsyncEffect from "use-async-effect";
import {useUserAuth} from "../../../../context/UserAuthContext";
import {AES, enc} from "crypto-js";
import {useNavigate} from "react-router-dom";
import axios from "axios";

const UserLevelAnalyticsPieChart = () => {

  const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
  const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

  //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
  //const CROMPTON_ANALYTICS_URL = "https://iot.crompton.co.in:8443/AAPI/"
  const secretKey = "cromptonssecretkey";

  let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
  const decryptedValueuname = AES.decrypt(Username, secretKey).toString(enc.Utf8);
  const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);
  const navigate = useNavigate();

  let [dataCount, setDataCount] = useState([]);
  let [options, setOptions] = useState([]);


  const [pieChartDataValues, setPieChartData] = useState([]);
  const [unit, setUnits] = useState([]);

  const handleLogOut = async () => {
    try {
      await logOut();
      navigate("/");
    } catch (error) {
      ////console.log(error.message);
    }
  }

  function getUserLevelAnalyticsApi() {
    if ((accesscontrollevel.toString() === "1") || (accesscontrollevel.toString() === "3") || accesscontrollevel.toString() === "5") {
      var chartLabels = [];
      var count = [];
      var url = CROMPTON_ANALYTICS_URL + "v1/user/levels"

      axios({
        method: "GET", url: url, headers: {
          Authorization: decryptedValue,
        }

      }).then((res) => {
        //console.log(res.data)
        for (var i = 3; i < 6; i++) {
          chartLabels.push(res.data[i].userLevel.replace(" Users", ""));
          count.push(res.data[i].count);
        }

        setPieChartData(count);
        setUnits(chartLabels)

        setDataCount(count)
        dataCount = count
        setOptions(chartLabels)
        options = chartLabels

        /*localStorage.setItem("units", JSON.stringify(chartLabels))
        localStorage.setItem("unitCounts", JSON.stringify(count))*/

        /*console.log("Data labels: ", chartLabels)
        console.log("Data values: ", count)*/

      }).catch((error) => {
        console.log(error)
        if (error.response.data.status === "401" || error.response.data.status === "403") {
          handleLogOut();
        }
      })

    } else {
      //console.log("Inside stats non admin")
      //setErrorMessage("You do not have permission to view this. Please contact admin.")
    }
  }

  useAsyncEffect( () => {

    getUserLevelAnalyticsApi()

    /*units =JSON.parse(localStorage.getItem("units"))
    unitCounts = JSON.parse(localStorage.getItem("unitCounts"))*/


  }, [""])
  return (
      <Card extra="rounded-[20px] p-3">
        <div className="flex flex-row justify-between px-3 pt-2">
          <div>
            <h4 className="text-lg font-bold text-navy-700 dark:text-white">
              User Level Analytics
            </h4>
          </div>
        </div>

        <br/>

        <div className="mb-auto flex h-[200px] w-full items-center justify-center">
          <PieChart options={{
            labels: options,
            colors: ["#9BBFE0", "#E8A09A", "#FBE29F"],
            chart: {
              width: "50px",
            },
            states: {
              hover: {
                filter: {
                  type: "none",
                },
              },
            },
            legend: {
              show: false,
            },
            dataLabels: {
              enabled: false,
            },
            hover: { mode: null },
            plotOptions: {
              donut: {
                expandOnClick: false,
                donut: {
                  labels: {
                    show: false,
                  },
                },
              },
            },
            fill: {
              colors: ["#9BBFE0", "#E8A09A", "#FBE29F"],
            },
            tooltip: {
              enabled: true,
              theme: "dark",
              style: {
                fontSize: "12px",
                fontFamily: undefined,
                backgroundColor: "#000000"
              },
            },
          }
          } series={dataCount} />
        </div>
        <div className="flex flex-row !justify-between rounded-2xl px-6 py-3 shadow-2xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none">
          <div className="flex flex-col items-center justify-center">
            <div className="flex items-center justify-center">
              <div className="h-2 w-2 rounded-full bg-[#E8A09A]" />
              <p className="ml-1 text-sm font-normal text-gray-600">{unit[1]}</p>
            </div>
            <p className="mt-px text-xl font-bold text-navy-700  dark:text-white">
              { (((pieChartDataValues[1] / (pieChartDataValues[0] + pieChartDataValues[1] + pieChartDataValues[2])) * 100).toFixed(1)) + "%"}
            </p>
          </div>

          <div className="h-11 w-px bg-gray-300 dark:bg-white/10" />

          <div className="flex flex-col items-center justify-center">
            <div className="flex items-center justify-center">
              <div className="h-2 w-2 rounded-full  bg-[#FBE29F]" />
              <p className="ml-1 text-sm font-normal text-gray-600">{unit[2]}</p>
            </div>
            <p className="mt-px text-xl font-bold text-navy-700  dark:text-white">
              { (((pieChartDataValues[2] / (pieChartDataValues[0] + pieChartDataValues[1] + pieChartDataValues[2])) * 100).toFixed(1)) + "%"}
            </p>
          </div>

          <div className="h-11 w-px bg-gray-300 dark:bg-white/10" />

          <div className="flex flex-col items-center justify-center">
            <div className="flex items-center justify-center">
              <div className="h-2 w-2 rounded-full bg-[#9BBFE0]" />
              <p className="ml-1 text-sm font-normal text-gray-600">{unit[0]}</p>
            </div>
            <p className="mt-px text-xl font-bold text-navy-700 dark:text-white">
              { (((pieChartDataValues[0] / (pieChartDataValues[0] + pieChartDataValues[1] + pieChartDataValues[2])) * 100).toFixed(1)) + "%"}
            </p>
          </div>
        </div>
      </Card>
  );
};

export default UserLevelAnalyticsPieChart;
